import { _ as _slicedToArray } from './_rollupPluginBabelHelpers-76ab84fa.js';
import React, { useState, useEffect } from 'react';

var translateLoadJS = function translateLoadJS(callback) {
  var initGoogleTranslate = document.getElementById("initGoogleTranslate");

  if (!initGoogleTranslate) {
    var script = document.createElement("script");
    script.src = "https://cdn1.accropress.com/initGoogleTranslate.js";
    script.id = "initGoogleTranslate";
    document.body.appendChild(script);

    script.onload = function () {
      if (callback) callback();
    };
  }

  var googleTranslateElementInit = document.getElementById("googleTranslateElementInit");

  if (!googleTranslateElementInit) {
    var _script = document.createElement("script");

    _script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    _script.id = "initGoogleTranslate";
    document.body.appendChild(_script);

    _script.onload = function () {
      if (callback) callback();
    };
  }

  if (initGoogleTranslate && googleTranslateElementInit && callback) callback();
};

var Translate = function Translate(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  useEffect(function () {
    translateLoadJS(function () {
      setLoaded(true);
    });
  }, []);
  var Html = props.html || /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "google_translate_element",
    className: "google_translate_element loading_".concat(loaded)
  }, /*#__PURE__*/React.createElement("div", {
    className: "skiptranslate goog-te-gadget",
    dir: "ltr"
  }, /*#__PURE__*/React.createElement("div", {
    id: ":0.targetLanguage"
  }, /*#__PURE__*/React.createElement("select", {
    className: "goog-te-combo",
    "aria-label": "Language Translate Widget"
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Select Language"), /*#__PURE__*/React.createElement("option", {
    value: "af"
  }, "Afrikaans"), /*#__PURE__*/React.createElement("option", {
    value: "sq"
  }, "Albanian"), /*#__PURE__*/React.createElement("option", {
    value: "am"
  }, "Amharic"), /*#__PURE__*/React.createElement("option", {
    value: "ar"
  }, "Arabic"), /*#__PURE__*/React.createElement("option", {
    value: "hy"
  }, "Armenian"), /*#__PURE__*/React.createElement("option", {
    value: "az"
  }, "Azerbaijani"), /*#__PURE__*/React.createElement("option", {
    value: "eu"
  }, "Basque"), /*#__PURE__*/React.createElement("option", {
    value: "be"
  }, "Belarusian"), /*#__PURE__*/React.createElement("option", {
    value: "bn"
  }, "Bengali"), /*#__PURE__*/React.createElement("option", {
    value: "bs"
  }, "Bosnian"), /*#__PURE__*/React.createElement("option", {
    value: "bg"
  }, "Bulgarian"), /*#__PURE__*/React.createElement("option", {
    value: "ca"
  }, "Catalan"), /*#__PURE__*/React.createElement("option", {
    value: "ceb"
  }, "Cebuano"), /*#__PURE__*/React.createElement("option", {
    value: "ny"
  }, "Chichewa"), /*#__PURE__*/React.createElement("option", {
    value: "zh-CN"
  }, "Chinese (Simplified)"), /*#__PURE__*/React.createElement("option", {
    value: "zh-TW"
  }, "Chinese (Traditional)"), /*#__PURE__*/React.createElement("option", {
    value: "co"
  }, "Corsican"), /*#__PURE__*/React.createElement("option", {
    value: "hr"
  }, "Croatian"), /*#__PURE__*/React.createElement("option", {
    value: "cs"
  }, "Czech"), /*#__PURE__*/React.createElement("option", {
    value: "da"
  }, "Danish"), /*#__PURE__*/React.createElement("option", {
    value: "nl"
  }, "Dutch"), /*#__PURE__*/React.createElement("option", {
    value: "eo"
  }, "Esperanto"), /*#__PURE__*/React.createElement("option", {
    value: "et"
  }, "Estonian"), /*#__PURE__*/React.createElement("option", {
    value: "tl"
  }, "Filipino"), /*#__PURE__*/React.createElement("option", {
    value: "fi"
  }, "Finnish"), /*#__PURE__*/React.createElement("option", {
    value: "fr"
  }, "French"), /*#__PURE__*/React.createElement("option", {
    value: "fy"
  }, "Frisian"), /*#__PURE__*/React.createElement("option", {
    value: "gl"
  }, "Galician"), /*#__PURE__*/React.createElement("option", {
    value: "ka"
  }, "Georgian"), /*#__PURE__*/React.createElement("option", {
    value: "de"
  }, "German"), /*#__PURE__*/React.createElement("option", {
    value: "el"
  }, "Greek"), /*#__PURE__*/React.createElement("option", {
    value: "gu"
  }, "Gujarati"), /*#__PURE__*/React.createElement("option", {
    value: "ht"
  }, "Haitian Creole"), /*#__PURE__*/React.createElement("option", {
    value: "ha"
  }, "Hausa"), /*#__PURE__*/React.createElement("option", {
    value: "haw"
  }, "Hawaiian"), /*#__PURE__*/React.createElement("option", {
    value: "iw"
  }, "Hebrew"), /*#__PURE__*/React.createElement("option", {
    value: "hi"
  }, "Hindi"), /*#__PURE__*/React.createElement("option", {
    value: "hmn"
  }, "Hmong"), /*#__PURE__*/React.createElement("option", {
    value: "hu"
  }, "Hungarian"), /*#__PURE__*/React.createElement("option", {
    value: "is"
  }, "Icelandic"), /*#__PURE__*/React.createElement("option", {
    value: "ig"
  }, "Igbo"), /*#__PURE__*/React.createElement("option", {
    value: "id"
  }, "Indonesian"), /*#__PURE__*/React.createElement("option", {
    value: "ga"
  }, "Irish"), /*#__PURE__*/React.createElement("option", {
    value: "it"
  }, "Italian"), /*#__PURE__*/React.createElement("option", {
    value: "ja"
  }, "Japanese"), /*#__PURE__*/React.createElement("option", {
    value: "jw"
  }, "Javanese"), /*#__PURE__*/React.createElement("option", {
    value: "kn"
  }, "Kannada"), /*#__PURE__*/React.createElement("option", {
    value: "kk"
  }, "Kazakh"), /*#__PURE__*/React.createElement("option", {
    value: "km"
  }, "Khmer"), /*#__PURE__*/React.createElement("option", {
    value: "rw"
  }, "Kinyarwanda"), /*#__PURE__*/React.createElement("option", {
    value: "ko"
  }, "Korean"), /*#__PURE__*/React.createElement("option", {
    value: "ku"
  }, "Kurdish (Kurmanji)"), /*#__PURE__*/React.createElement("option", {
    value: "ky"
  }, "Kyrgyz"), /*#__PURE__*/React.createElement("option", {
    value: "lo"
  }, "Lao"), /*#__PURE__*/React.createElement("option", {
    value: "la"
  }, "Latin"), /*#__PURE__*/React.createElement("option", {
    value: "lv"
  }, "Latvian"), /*#__PURE__*/React.createElement("option", {
    value: "lt"
  }, "Lithuanian"), /*#__PURE__*/React.createElement("option", {
    value: "lb"
  }, "Luxembourgish"), /*#__PURE__*/React.createElement("option", {
    value: "mk"
  }, "Macedonian"), /*#__PURE__*/React.createElement("option", {
    value: "mg"
  }, "Malagasy"), /*#__PURE__*/React.createElement("option", {
    value: "ms"
  }, "Malay"), /*#__PURE__*/React.createElement("option", {
    value: "ml"
  }, "Malayalam"), /*#__PURE__*/React.createElement("option", {
    value: "mt"
  }, "Maltese"), /*#__PURE__*/React.createElement("option", {
    value: "mi"
  }, "Maori"), /*#__PURE__*/React.createElement("option", {
    value: "mr"
  }, "Marathi"), /*#__PURE__*/React.createElement("option", {
    value: "mn"
  }, "Mongolian"), /*#__PURE__*/React.createElement("option", {
    value: "my"
  }, "Myanmar (Burmese)"), /*#__PURE__*/React.createElement("option", {
    value: "ne"
  }, "Nepali"), /*#__PURE__*/React.createElement("option", {
    value: "no"
  }, "Norwegian"), /*#__PURE__*/React.createElement("option", {
    value: "or"
  }, "Odia (Oriya)"), /*#__PURE__*/React.createElement("option", {
    value: "ps"
  }, "Pashto"), /*#__PURE__*/React.createElement("option", {
    value: "fa"
  }, "Persian"), /*#__PURE__*/React.createElement("option", {
    value: "pl"
  }, "Polish"), /*#__PURE__*/React.createElement("option", {
    value: "pt"
  }, "Portuguese"), /*#__PURE__*/React.createElement("option", {
    value: "pa"
  }, "Punjabi"), /*#__PURE__*/React.createElement("option", {
    value: "ro"
  }, "Romanian"), /*#__PURE__*/React.createElement("option", {
    value: "ru"
  }, "Russian"), /*#__PURE__*/React.createElement("option", {
    value: "sm"
  }, "Samoan"), /*#__PURE__*/React.createElement("option", {
    value: "gd"
  }, "Scots Gaelic"), /*#__PURE__*/React.createElement("option", {
    value: "sr"
  }, "Serbian"), /*#__PURE__*/React.createElement("option", {
    value: "st"
  }, "Sesotho"), /*#__PURE__*/React.createElement("option", {
    value: "sn"
  }, "Shona"), /*#__PURE__*/React.createElement("option", {
    value: "sd"
  }, "Sindhi"), /*#__PURE__*/React.createElement("option", {
    value: "si"
  }, "Sinhala"), /*#__PURE__*/React.createElement("option", {
    value: "sk"
  }, "Slovak"), /*#__PURE__*/React.createElement("option", {
    value: "sl"
  }, "Slovenian"), /*#__PURE__*/React.createElement("option", {
    value: "so"
  }, "Somali"), /*#__PURE__*/React.createElement("option", {
    value: "es"
  }, "Spanish"), /*#__PURE__*/React.createElement("option", {
    value: "su"
  }, "Sundanese"), /*#__PURE__*/React.createElement("option", {
    value: "sw"
  }, "Swahili"), /*#__PURE__*/React.createElement("option", {
    value: "sv"
  }, "Swedish"), /*#__PURE__*/React.createElement("option", {
    value: "tg"
  }, "Tajik"), /*#__PURE__*/React.createElement("option", {
    value: "ta"
  }, "Tamil"), /*#__PURE__*/React.createElement("option", {
    value: "tt"
  }, "Tatar"), /*#__PURE__*/React.createElement("option", {
    value: "te"
  }, "Telugu"), /*#__PURE__*/React.createElement("option", {
    value: "th"
  }, "Thai"), /*#__PURE__*/React.createElement("option", {
    value: "tr"
  }, "Turkish"), /*#__PURE__*/React.createElement("option", {
    value: "tk"
  }, "Turkmen"), /*#__PURE__*/React.createElement("option", {
    value: "uk"
  }, "Ukrainian"), /*#__PURE__*/React.createElement("option", {
    value: "ur"
  }, "Urdu"), /*#__PURE__*/React.createElement("option", {
    value: "ug"
  }, "Uyghur"), /*#__PURE__*/React.createElement("option", {
    value: "uz"
  }, "Uzbek"), /*#__PURE__*/React.createElement("option", {
    value: "vi"
  }, "Vietnamese"), /*#__PURE__*/React.createElement("option", {
    value: "cy"
  }, "Welsh"), /*#__PURE__*/React.createElement("option", {
    value: "xh"
  }, "Xhosa"), /*#__PURE__*/React.createElement("option", {
    value: "yi"
  }, "Yiddish"), /*#__PURE__*/React.createElement("option", {
    value: "yo"
  }, "Yoruba"), /*#__PURE__*/React.createElement("option", {
    value: "zu"
  }, "Zulu"))), /*#__PURE__*/React.createElement("div", {
    className: "poweredBy"
  }, "Powered by Google Translate"))));
  return Html;
};

export default Translate;